import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { JoyrideHits } from "../../../components/joyride/whiteLabel/JoyrideHits";
import Wrapper from "../../../components/wrapper";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";
import useIsDomainMode from "../../../hooks/useIsDomainMode";
import FirstStep from "./firstStep";
import SecondStep from "./secondStep";
import StepsInfo from "./StepsInfo";
import ThirdStep from "./thirdStep";

export default function AddDomainSubdomain() {
  const { t } = useTranslation();
  const urlLocale = useGetUrlLocale();
  const isDomainMode = useIsDomainMode();
  const [step, setStep] = useState(1);
  const [userDomain, setUserDomain] = useState("");

  const handleSetUserDomain = (domain: string) => {
    setUserDomain(domain);
  };

  return (
    <Wrapper mainBlockClassName="white-label-wrapper">
      <Container id="add-domain">
        <h2 className="fw-bold fs-1 mb-3">
          {isDomainMode
            ? t("whiteLabel.Add Domain")
            : t("whiteLabel.Add Subdomain")}
        </h2>
        <div className="fs-7 text-info mb-4">
          <Link className="text-success" to={`${urlLocale}/custom-domain`}>
            {t("menu.Custom Domain")}
          </Link>{" "}
          /{" "}
          {isDomainMode
            ? t("whiteLabel.Add Domain")
            : t("whiteLabel.Add Subdomain")}
        </div>

        <StepsInfo step={step} />
        {step === 1 && (
          <FirstStep
            setStep={setStep}
            handleSetUserDomain={handleSetUserDomain}
            userDomain={userDomain}
          />
        )}
        {step === 2 && <SecondStep setStep={setStep} userDomain={userDomain} />}
        {step === 3 && <ThirdStep />}
      </Container>
      <JoyrideHits />
    </Wrapper>
  );
}
